import api from '@/api'
// import router from '@/router'

const isLoggedIn = localStorage.getItem('token')
export const redirect = () => {
  // router.push('/');
  // document.location.reload()
  document.location.href = '/'
}

// auth
export const authLogout = ({ commit }, payload) => {
  localStorage.removeItem('token')
  localStorage.removeItem('userData')
  localStorage.removeItem('consentSeen')
  localStorage.removeItem('consentHead')
  localStorage.removeItem('impersonated')
  localStorage.removeItem('userIndustryName')
  localStorage.removeItem('userCompanyName')
  commit('authLogout')
  commit('changeImpersonate', false)
  redirect()
}

export const getContentById = ({ commit }, payload, id) => {
  if (isLoggedIn) {
    const urlEnd = `${api.URLS.content}/${this.id}`
    const type = 'get'
    api.requestToServer(urlEnd, type, payload, id)
    .then((res) => {
      this.contentItem = res.body
    })
    .catch((err) => console.error(err))
  }
}

export const getUserRoles = ({ commit }, payload) => {
  let token = localStorage.getItem('token')
  let userData = JSON.parse(localStorage.getItem('userData'))
  if (token && userData) {
    const urlEnd = api.URLS.userRoles + token
    const type = 'get'
    let headers = { headers: {'Authorization': 'Bearer ' + token} }
    api.requestToServer(urlEnd, type, headers)
    .then((res) => {
      let userRole = res.body
      if (userRole === 'ca' && localStorage.getItem('consentHead') === 'true') {
        userRole = 'sh'
      }
      userData.userRole = userRole
      localStorage.setItem('userData', JSON.stringify(userData))
      commit('authLoginSetUserRole', userRole)
      commit('authLoginSetCompany', userData.company)
    })
    .catch((err) => console.log(err))
  }
}

export const getUser = ({ commit }) => {
  api.requestToServer(api.URLS.profileEnd, 'put', api.headersAuthSettings, api.timeout, {})
    .then((res) => {
      commit('setProfile', res.body)
    })
    .catch((err) => console.log(err))
}

export const setFontSizeActive = ({ commit }) => {
  let fontSizeActive = localStorage.getItem('selectedFont') ? +localStorage.getItem('selectedFont') : 0
  let fontSizeButtons = document.getElementsByClassName('text-resize-controls__button')
  let activeFontSizeTrigger = document.getElementById('accessibilityFontSize_' + fontSizeActive)
  for (let i = 0; i < fontSizeButtons.length; i++) {
    fontSizeButtons[i].classList.remove('active')
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-size-0', 'accessibility-size-1', 'accessibility-size-2')
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-size-' + fontSizeActive)
  if (activeFontSizeTrigger) {
    activeFontSizeTrigger.classList.add('active')
  }
  commit('resizeText', fontSizeActive)
}

export const setColorPaletteActive = () => {
  let colorPaletteActive = localStorage.getItem('selectedHightCont') ? +localStorage.getItem('selectedHightCont') : 0
  let colorPaletteButtons = document.getElementsByClassName('color-change-controls__button')
  let activeColorTrigger = document.getElementById('accessibilityColorPalette_' + colorPaletteActive)
  for (let i = 0; i < colorPaletteButtons.length; i++) {
    colorPaletteButtons[i].classList.remove('active')
  }
  document.getElementsByTagName('BODY')[0].classList.remove('accessibility-color-0', 'accessibility-color-1', 'accessibility-color-2')
  document.getElementsByTagName('BODY')[0].classList.add('accessibility-color-' + colorPaletteActive)
  if (activeColorTrigger) {
    activeColorTrigger.classList.add('active')
  }
}

export const getTypes = ({ commit }, payload) => {
  const urlEnd = api.URLS.contentTypes
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTypes', res.body.items)
    })
    .catch((err) => console.error(err))
  }
}

export const getChapters = ({ commit }, payload) => {
  const urlEnd = api.URLS.contentChapters
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setChapters', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getTaskChapters = ({ commit }, companyId, payload) => {
  let urlEnd = `${api.URLS.taskNoBase}/chapters`
  if (companyId) {
    urlEnd += '?company=' + companyId
  }
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTaskChapters', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getTaskStatuses = ({ commit }, companyId, payload) => {
  let urlEnd = `${api.URLS.taskNoBase}/statuses`
  if (companyId) {
    urlEnd += '?company=' + companyId
  }
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTaskStatuses', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getTaskMandatory = ({ commit }, data, payload) => {
  let urlEnd = `${api.URLS.taskNoBase}/mandatory`
  if (data.company) {
    urlEnd += '?company=' + data.company
    if (data.board) {
      urlEnd += '&board=' + data.board
    }
  } else {
    if (data.board) {
      urlEnd += '?board=' + data.board
    }
  }
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTaskMandatory', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getTaskAssignee = ({ commit }, companyId, payload) => {
  let urlEnd = `${api.URLS.taskNoBase}/assignee`
  if (companyId) {
    urlEnd += '?company=' + companyId
  }
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTaskAssignee', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getAdminUsers = ({ commit }, payload) => {
  let urlEnd = `${api.URLS.adminUsers}`
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setAdminUsers', res.body)
    })
    .catch((err) => console.error(err))
  }
}

export const getTags = ({ commit }, payload) => {
  const urlEnd = api.URLS.tagsSimple
  const type = 'get'
  if (isLoggedIn) {
    api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      commit('setTags', res.body.items)
    })
    .catch((err) => console.error(err))
  }
}

export const getActions = ({ commit }, payload) => {
  const urlEnd = api.URLS.actionsURLS.actions
  const type = 'get'
  api.requestToServer(urlEnd, type, payload)
  .then((res) => {
    console.log('getActions', res)
    commit('setActions', res.body)
  })
  .catch((err) => console.log(err))
}

export const getRoles = ({ commit }, payload) => {
  const urlEnd = api.URLS.roles
  const type = 'get'
  api.requestToServer(urlEnd, type, payload)
  .then((res) => commit('setRoles', res.body))
  .catch((err) => console.log(err))
}

export const getCategories = ({ commit }, payload) => {
  const urlEnd = api.URLS.categories
  const type = 'get'
  api.requestToServer(urlEnd, type, payload)
    .then((res) => {
      let result = []
      const categories = res.body.items.filter(item => !item.parent)
      categories.forEach(item => {
        result.push(item)
        if (item.children.length) {
          item.children.forEach(child => {
            let curChild = child
            curChild.isChild = true
            curChild.parent = {
              label: item.title,
              value: item.id
            }
            result.push(curChild)
          })
        }
      })
      commit('setCategories', result)
    })
    .catch((err) => console.log(err))
}

export const getCompanies = ({ commit }, payload) => {
  api.requestToServer(api.URLS.companies, 'get')
    .then((res) => {
      let companies = res.body.data.items
      let parents = []
      companies.sort((a, b) => a.name > b.name).forEach(function (company) {
        if (company.parent === null) {
          let children = companies.filter(item => item.parent !== null && item.parent.id === company.id)
          parents.push(company)
          children.forEach(function (child) {
            parents.push(child)
          })
        }
      })
      commit('setCompanies', parents)
    })
    .catch((err) => console.log(err))
}

export const getIndustries = ({ commit }, payload) => {
  api.requestToServer(api.URLS.industries, 'get')
      .then((res) => {
        let industries = res.body.items
        let parents = []
        industries.sort((a, b) => a.name > b.name).forEach(function (industry) {
          if (industry.parent === null) {
            let children = industries.filter(item => item.parent !== null && item.parent.id === industry.id)
            parents.push(industry)
            children.forEach(function (child) {
              parents.push(child)
            })
          }
        })
        commit('setIndustries', parents)
      })
      .catch((err) => console.log(err))
}

export const getDefaultRegistrationRoles = ({ commit }, payload) => {
  let token = localStorage.getItem('token')
  let userData = JSON.parse(localStorage.getItem('userData'))
  if (token && userData) {
    const urlEnd = api.URLS.defaultRegistrationRoles
    const type = 'get'
    let headers = { headers: {'Authorization': 'Bearer ' + token} }
    api.requestToServer(urlEnd, type, headers)
      .then((res) => {
        commit('setDefaultRegistrationRoles', res.body)
      })
      .catch((err) => console.log('error', err))
  }
}

export const getSponsors = ({ commit }, payload) => {
  api.requestToServer(api.URLS.sponsors + '/' + payload, 'get')
      .then((res) => commit('setSponsors', res.body))
      .catch((err) => console.log(err))
}

export const getLngs = ({ commit }, payload) => {
  api.requestToServer(api.URLS.languages, 'get')
    .then((res) => commit('setLanguages', res.body.items))
    .catch((err) => console.log(err))
}

export const getCompanySizes = ({ commit }, payload) => {
  api.requestToServer(api.URLS.companySizes, 'get')
    .then((res) => commit('setCompanySizes', res.body))
    .catch((err) => console.log(err))
}

export const getCompanyLocations = ({ commit }, payload) => {
  api.requestToServer(api.URLS.companyLocations, 'get')
    .then((res) => commit('setCompanyLocations', res.body))
    .catch((err) => console.log(err))
}

export const getCompanyOrganizationTypes = ({ commit }) => {
  api.requestToServer(api.URLS.companyOrganizationTypes, 'get')
    .then((res) => commit('setCompanyOrganizationTypes', res.body))
    .catch((err) => console.log(err))
}

export const setDataPreviewArticle = ({ commit }, payload) => {
  commit('setDataPreviewArticle', payload)
}

export const initConfAction = ({commit}, payload) => {
  commit('initConfAction', payload)
}

export const clearConfAction = ({commit}, payload) => {
  commit('clearConfAction', payload)
}

// Information block action
export const setInformationMsg = ({commit}, payload) => {
  commit('setInformationMsg', payload)
}

// Information block close action
export const closeInformationMsg = ({commit}, payload) => {
  commit('setInformationMsg', {
    isShown: false,
    title: '',
    text: '',
    className: ''
  })
}

export const setStyleForMsg = ({commit}, payload) => {
  commit('setStyleForMsg', payload)
}

export const resizeText = ({commit}, payload) => {
  commit('resizeText', payload)
}

export const changeVisibilityThem = ({commit}, payload) => {
  commit('changeVisibilityThem', payload)
}

export const changeConsent = ({commit}, payload) => {
  commit('consentRequired', payload)
}
// export const initConfAction = ({ commit }, payload) => {
//   commit('initConfAction', payload)
// }
//
// export const clearConfAction = ({ commit }, payload) => {
//   commit('clearConfAction', payload)
// }
//
// export const removeUserById = ({ commit }, payload) => {
//   const urlEnd = api.URLS.userRoles
//   const type = 'get'
//   api.requestToServer(urlEnd, type, payload)
//     .then((res) => {
//       let userRole = res.body[0]
//       localStorage.setItem('userRole', userRole)
//       commit('authLoginSetUserRole', userRole)
//     })
//     .catch((err) => console.log(err))
// }
//
// export const confCurAction = ({ commit, state }, payload) => {
//   switch (state.confData.actionName) {
//     case 'removeUserById':
//       removeUserById({ commit }, payload)
//       break
//   }
//   clearConfAction({commit})
// }



// WEBPACK FOOTER //
// ./src/store/actions.js